import React from 'react';
import { withRouter } from 'react-router-dom';
import Scheduler from '../../../../utils/Scheduler';

import FieldModal from '../../../../components/modals/fieldModal';

import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap';

class UnscheduleEmailModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {

			submitting: false
		}
	}
	pauseCampaign = async () => {
		const { orgId, eventId, toggle, email, update } = this.props;

		try {
			await Scheduler()
				.patch(`Organizations/${orgId}/textSchedules`, { textMessages: [email._id], request: 'unschedule' })
				.then((res) => {
					update(
						{
							scheduled: false,
							sendDate: '',
							sendTime: '',
							status: 'Draft'

						},
						() => {
							toggle();
						}
					);
				});
		} catch (e) {
			console.log(e);
		}
	};

	render() {
		const { email, isOpen, toggle } = this.props;
		const { submitting } = this.state;
		return (
			<div>

				<FieldModal
					size="small"
					isOpen={isOpen}
					modalTitle={"Pause Campaign"}
					bodyHeaderText={'Are you sure you want to pause this campaign?'}
					bodyContent={() => {
						return ('')
					}}
					toggle={toggle}
					actionButtonLabel={!submitting ? 'Pause' : 'Pausing...'}
					actionButton={() => this.pauseCampaign()}
					actionButtonDisabled={submitting}
				></FieldModal>
			</div>
		);
	}
}

export default withRouter(UnscheduleEmailModal);
